import {Group} from './group';
import { TripPeriodPrice } from './trip-period-price';
import { DurationUnit } from './duration-unit.enum';

export class SubscriptionPlan {
  id: number;
  name: string;
}

export class SubscriptionPlanItem {
  planId: number;
  planName: string;
  nbUser: number;
  groupId: number;
  groupName: string;
  status: SubscriptionPlanStatus;
}

export enum SubscriptionPlanStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export class SubscriptionPlanDetail {
  id: number;
  name: string;
  group: Group;
  authorizedBikes: Array<string>;
  /*
   * the following time are indicated in minutes
   */
  maxTimeWithdrawal: number;
  minTimeBetweenWithdrawals: number;
  numberOfWithdrawals: number;
  startTimeSlot: string;
  endTimeSlot: string;

  open: boolean;
  pay: boolean;

  duration: string;
  durationUnit: DurationUnit;

  autoRenewPossible: boolean;
  depositCents: number;
  priceCents: number;
  tripInitPriceCents: number;

  tripPeriodPrices: TripPeriodPrice[] = [];

  descriptionOne: string;
  descriptionTwo: string;
}




// WEBPACK FOOTER //
// ./src/app/models/subscriptionplan.ts